import { MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';
import { BrandFeatures } from 'hooks/useBrandFeatures';
import { User } from 'types';
import { permissions, PermissionCheck } from 'features/permissions';
import { constant } from 'lodash-es';
import { MIGRATIONS_ALLOWED_HOSTS } from './migrations';

type CheckUserAndFeatures = (user: User, features: BrandFeatures) => boolean;

interface MenuItem {
  permission?: PermissionCheck;
  feature?: keyof BrandFeatures;
  allowedHosts?: readonly string[];
  dividerBefore?: boolean;
  showInMainMenu: CheckUserAndFeatures;
  showInUserMenu: CheckUserAndFeatures;
  path: string;
  label: MessageDescriptor;
}

const SHOW = {
  never: constant(false),
  always: constant(true)
};

export const MENU: MenuItem[] = [
  {
    path: '/dashboard',
    label: msg`Dashboard`,
    showInMainMenu: permissions.isSuperAdmin,
    showInUserMenu: SHOW.never
  },
  {
    path: '/',
    label: msg`Главная`,
    showInMainMenu: permissions.not.isAdmin,
    showInUserMenu: SHOW.never
  },
  {
    path: '/users',
    label: msg`Пользователи`,
    showInMainMenu: permissions.isAdmin,
    showInUserMenu: SHOW.never
  },
  {
    path: '/userGroups',
    label: msg`Группы пользователей`,
    showInMainMenu: (user) =>
      permissions.isAdmin(user) && permissions.isGroupAdmin(user),
    showInUserMenu: SHOW.never
  },
  {
    path: '/terminals',
    label: msg`Аппараты`,
    showInMainMenu: SHOW.always,
    showInUserMenu: SHOW.always
  },
  {
    path: '/sales',
    label: msg`Продажи`,
    showInMainMenu: permissions.not.isAdmin,
    showInUserMenu: SHOW.always
  },
  {
    path: '/encash',
    label: msg`Инкассации`,
    showInMainMenu: permissions.not.isAdmin,
    showInUserMenu: SHOW.always
  },
  {
    path: '/services',
    label: msg`Услуги`,
    feature: 'services',
    showInMainMenu: permissions.not.isStaff,
    showInUserMenu: SHOW.always
  },
  {
    path: '/hwt',
    label: msg`Домашние системы очистки`,
    permission: permissions.can.manageHWT,
    feature: 'hwt',
    showInMainMenu: SHOW.always,
    showInUserMenu: SHOW.always
  },
  {
    path: '/update',
    label: msg`Прошивка оборудования`,
    showInMainMenu: permissions.isSuperAdmin.or(permissions.isFirmwareAdmin),
    showInUserMenu: SHOW.never
  },
  {
    path: '/vendor',
    label: msg`Школа вендора`,
    showInMainMenu: permissions.not.isBlockedUser,
    showInUserMenu: SHOW.never
  },
  {
    path: 'https://drive.google.com/drive/folders/1dlEp5K3l16udv_iht_2yJ1hXlNbiJ5-e',
    label: msg`Школа вендора`,
    showInMainMenu: permissions.isBlockedUser,
    showInUserMenu: SHOW.never
  },
  {
    path: '/oracle',
    label: msg`Проект Оракул`,
    showInMainMenu: permissions.not.isStaff,
    showInUserMenu: permissions.not.isStaff
  },
  {
    path: '/userLogs',
    label: msg`Логи пользователя`,
    showInMainMenu: SHOW.never,
    showInUserMenu: SHOW.always
  },
  {
    path: '/omnidesk',
    label: msg`ОМНИДЕСК-сообщения`,
    showInMainMenu: permissions.isGroupAdmin,
    showInUserMenu: SHOW.never,
    feature: 'omni'
  },
  {
    path: '/staff',
    label: msg`Сотрудники`,
    showInMainMenu: permissions.not.isStaff,
    showInUserMenu: permissions.not.isStaff
  },
  {
    path: '/storeOrders',
    label: msg`Мои заказы`,
    showInMainMenu: (_, features) => features.shop,
    showInUserMenu: (_, features) => features.shop
  },
  {
    path: '/system/maintenance',
    label: msg`Технические работы`,
    allowedHosts: [
      'kk-perm.alivewater.online',
      'alivewater.online',
      'perm.alivewater.online'
    ],
    dividerBefore: true,
    showInMainMenu: permissions.isSuperAdmin,
    showInUserMenu: SHOW.never
  },
  {
    path: '/migrations',
    label: msg`Миграции`,
    allowedHosts: MIGRATIONS_ALLOWED_HOSTS,
    showInMainMenu: permissions.isSuperAdmin,
    showInUserMenu: SHOW.never
  }
];
